import { render } from "./FormularioTestDrive.vue?vue&type=template&id=613291fb&ts=true"
import script from "./FormularioTestDrive.vue?vue&type=script&lang=ts"
export * from "./FormularioTestDrive.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/hubevt/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__